import { useQuery } from 'react-query';
import { getProjectEmails } from '../../api/getEmails';

export function useGetProjectEmail(projectId: string) {
  return useQuery(['emails', projectId], () => getProjectEmails(projectId));
}
